<template>
  <div class="container-fluid">
    <div class="contents tournament">
      <h4 class="subtitle">
        <p class="badge-group">
          <span class="badge tourn-type">
            {{ tournament_type(tournamentinfo.tourtype_fk) }}
          </span>
          <span class="badge tourn-game-type">
            {{ game_type(tournamentinfo.gametype_fk) }}
          </span>
        </p>
        <p class="tourn-title">
          {{ tournamentinfo.title }}
        </p>
        <p class="tourn-rank-type">
          {{ tournamentinfo.tour_rank_type | tour_rank_type }}
        </p>           
      </h4>
      <!-- <p class="info">{{ tournamentinfo.remark }}</p> -->
      <div class="row row-cols-1 row-cols-lg-auto gy-2 lh-sm">
        <div class="col text-date">
          <!-- 서비스 시간 -->
          {{ tournamentinfo.timezone_startdate | dateformat }} ~
          {{ tournamentinfo.timezone_enddate | dateformat }}
        </div>
      </div>
      <div>
        <p class="pt-4 text-subscript text-info" v-if="tournamentinfo.gametype_fk==9">
          <span class="material-icons-outlined">info</span>
          {{ $t("text.common.offline_scramble_txt") }}
        </p>  
      </div>    
      
      <div class="border-top-dgray mt-4">
        <div class="row g-0 border-bottom">
          <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
            <label class="d-table-cell">{{
              $t("title.tournament.tournament_participation_type")
            }}</label>
          </div>
          <div class="col-8 col-lg-10">
            <p class="d-table-cell">
              {{ $t("text.common.participation") }} {{ tournament_particiaption_type(tournamentinfo.participationtype_fk) }}
            </p>
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
            <label class="d-table-cell">{{
              $t("title.common.information")
            }}</label>
          </div>
          <div class="col-8 col-lg-10">
            <p class="d-table-cell">
              {{ tournamentinfo.remark }}
            </p>
          </div>
        </div>        
        <div class="row g-0 border-bottom">
          <div class="col-4 col-lg-2 bg-gray row g-0 g-0 align-items-center">
            <label class="d-table-cell">{{ $t("title.common.course") }}</label>
          </div>
          <div class="col-8 col-lg-10">
            <p class="d-table-cell">
              <span v-for="(course, index) in tournamentcourse" :key="index"
                >{{ index === 0 ? "" : ", " }}{{ course.coursename }}</span
              >
            </p>
          </div>
        </div>
        <div class="row g-0 border-bottom">
          <div class="row g-0 col-4 col-lg-2 bg-gray align-item-center">
            <label class="d-table-cell align-self-center">{{
              $t("title.tournament.subcourse")
            }}</label>
          </div>
          <div v-if="subcourselistcnt" class="col-8 col-lg-10">
            <div
              v-for="(anc, index1) in subcourselist"
              :key="'k_' + index1"
              class="subcourse"
            >
              <h6 class="pt-1-">{{ anc.subcoursename }}</h6>
              <small class="d-block text-dgray"
                >{{ $t("title.tournament.subcourse") }}
                {{ anc.subcourseseq }}</small
              >
            </div>
          </div>
        </div>
        <div class="row g-0 border-bottom" v-if="tournamentinfo.gametype_fk==1">
          <div class="row g-0 col-4 col-lg-2 bg-gray align-item-center">
            <label class="d-table-cell align-self-center">{{
              $t("title.common.point_allocation")
            }}</label>
          </div>
          <div class="col-8 col-lg-10">
            <p class="d-table-cell">
              <span>
                {{ tournamentinfo.tour_class | tour_class }}
                {{ $t("title.common.standard_point") }}
                {{
                  tournamentinfo.oom_point == 1
                    ? "+ " + $t("title.common.oom_point")
                    : ""
                }}
              </span>
            </p>
          </div>
        </div>
      </div>

      <div class="border-top-dgray mt-5">
        <!-- <div class="row g-0">
          <div class="col-lg-2 row g-0 bg-gray border-bottom align-items-center">
            <label class="d-table-cell">매장</label>
          </div>
          <div class="col-lg-10 border-bottom">
            <p class="d-table-cell">
              <span v-for="(shop, index2) in tournamentshop" :key="index2"
                >{{ index2 === 0 ? "" : " / " }}{{ shop.shopname }}</span
              >
            </p>
          </div>
        </div> -->
        <div class="row g-0">
          <div
            class="col-lg-2 row g-0 bg-gray border-bottom align-items-center"
          >
            <label class="d-table-cell">{{ $t("title.event.prizes") }}</label>
          </div>
          <div class="col-lg-10 border-bottom">
            <div class="row g-0 border-bottom">
              <div class="col-lg-12">
                <p class="d-table-cell">
                  {{
                    tournamentprizeetc.etcprize ||
                    $t("text.common.unregistered")
                  }}
                </p>
              </div>
            </div>
            <div class="row g-0 border-bottom-0">
              <div class="col-lg-12">
                <p class="d-table-cell">
                  <span
                    class="d-block"
                    v-for="(rank, index3) in tournamentprizerank"
                    :key="index3"
                    ><strong class="fw-500 text-black">{{ $t("text.tournament.top") }} {{ rank.rankno }}</strong> :
                    <span class="text-prize">{{ rank.rankprize | comma }}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row g-0" v-if="tournamentinfo.gametype_fk==1">
          <div
            class="col-lg-2 bg-gray row g-0 align-items-center border-bottom"
          >
            <label class="d-table-cell">{{
              $t("title.tournament.conditions")
            }}</label>
          </div>
          <div class="col-lg-10">
            <div class="row g-0 border-bottom-0">
              <div
                class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
              >
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.game_mode")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournamentdetail.mode || "Unregistered" }}
                    </p>
                  </div>
                </div>
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.level")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournament_level(tournamentdetail.level) }}
                    </p>
                  </div>
                </div>

                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.common.greenspeed")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournamentinfo.greenspeed_fk | greenspeed }}
                    </p>
                  </div>
                </div>

                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.event.entrylimit")
                    }}</label>
                  </div>
                  <div class="col-8 row g-0 align-items-center">
                    <p class="d-table-cell text-red">
                      {{ tournamentinfo.entrylimit | transToValue("∞") }}
                    </p>
                  </div>
                </div>
                <div
                  class="row g-0 border-bottom d-flex flex-row align-items-stretch h-100"
                >
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.mulligan")
                    }}</label>
                  </div>
                  <div class="col-8 row g-0 align-items-center">
                    <p class="d-table-cell">
                      {{ tournamentdetail.mulligan || "Unregistered" }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-6 d-table-cell d-flex flex-column align-items-stretch"
              >
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.play_format")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournamentdetail.hole || "Unregistered" }}
                    </p>
                  </div>
                </div>
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.wind")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">{{ wind || "Unregistered" }}</p>
                  </div>
                </div>

                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.common.greengravity")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournamentinfo.greengravity_fk | greengravity }}
                    </p>
                  </div>
                </div>
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.tournament.rank_type")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ tournamentinfo.tour_rank_type | tour_rank_type }}
                    </p>
                  </div>
                </div>
                <div class="row g-0 border-bottom">
                  <div class="col-4 bg-lightgray row g-0 align-items-center">
                    <label class="d-table-cell">{{
                      $t("title.event.teebox")
                    }}</label>
                  </div>
                  <div class="col-8">
                    <p class="d-table-cell">
                      {{ $t("text.common.male") }}:
                      {{ teemale || "Unregistered" }}<br />
                      {{ $t("text.common.female") }}:
                      {{ teefemale || "Unregistered" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="row g-0 border-bottom-0">
              <div class="col-lg-3 bg-gray row align-items-center">
                <label class="d-table-cell">Handicap(No. of Play)</label>
              </div>
              <div class="col-lg-9">
                <p class="d-table-cell">{{ tournamentdetail.playhandicap }}</p>
              </div>
            </div> -->
          </div>
        </div>

        <Router-View />
        <div class="btn-bottom-wrapper">
          <b-button
            size="xl"
            variant="outline-primary"
            aria-label="list"
            @click="
              $router
                .push({
                  name: 'TournamentList',
                  query: {
                    searchtype: $route.query.searchtype,
                    searchname: $route.query.searchname,
                  },
                })
                .catch(() => {})
            "
          >
            {{ $t("button.common.list") }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ax from "@/api/tournament";
import "@/filter/common";
import { myMixin } from "@/mixin/myMixin";

export default {
  name: "TournamentCondition",
  data() {
    return {
      tournamentno: this.$route.params.tournamentno,
      tournamentinfo: [
        {
          title: "",
          remark: "",
          startdate: "",
          enddate: "",
        },
      ],
      tournamentcourse: [],
      tournamentshop: [],
      tournamentprizeetc: [
        {
          etcprize: "",
        },
      ],
      tournamentprizerank: [],
      tournamentdetail: [
        {
          mode: "",
          hole: "",
          level: "",
          wind: "",
          mulligan: "",
          teeboxman: "",
          teeboxwoman: "",
          playhandicap: "",
        },
      ],
      wind: "",
      teemale: "",
      teefemale: "",
      subcourselist: [],
      subcourselistcnt: 0,
    };
  },
  methods: {
    get_tournamentcondition() {
      ax.get_tournamentcondition(this.tournamentno, (flag, data) => {
        if (flag) {
          this.tournamentinfo = data.tournamentinfo;
          this.tournamentcourse = data.tournamentcourse;
          this.tournamentshop = data.tournamentshop;
          this.tournamentprizeetc = data.tournamentprizeetc;
          this.tournamentprizerank = data.tournamentprizerank;
          this.tournamentdetail = data.tournamentdetail;
          this.subcourselist = data.subcourselist;
          this.subcourselistcnt = data.subcourselistcnt;
          this.change_wind(this.tournamentdetail.wind);
          this.change_male(this.tournamentdetail.teeboxman);
          this.change_female(this.tournamentdetail.teeboxwoman);
        } else {
          alert(data);
        }
      });
    },
    // change_wind(wind) {
    //   if (wind === "0") {
    //     this.wind = this.$i18n.t("text.common.calm");
    //   } else if (wind === "1") {
    //     this.wind = this.$i18n.t("text.common.light");
    //   } else if (wind === "2") {
    //     this.wind = this.$i18n.t("text.common.moderate");
    //   } else if (wind === "3") {
    //     this.wind = this.$i18n.t("text.common.strong");
    //   } else if (wind === "4") {
    //     this.wind = this.$i18n.t("text.common.random");
    //   } else {
    //     this.wind = wind;
    //   }
    // },
    // change_male(teeboxman) {
    //   if (teeboxman === "1") {
    //     this.teemale =
    //       this.$i18n.t("text.common.pro") +
    //       "(" +
    //       this.$i18n.t("text.common.blue") +
    //       ")";
    //   } else if (teeboxman === "2") {
    //     this.teemale =
    //       this.$i18n.t("text.common.regular") +
    //       "(" +
    //       this.$i18n.t("text.common.white") +
    //       ")";
    //   } else if (teeboxman === "3") {
    //     this.teemale =
    //       this.$i18n.t("text.common.lady") +
    //       "(" +
    //       this.$i18n.t("text.common.red") +
    //       ")";
    //   } else {
    //     this.teemale = teeboxman;
    //   }
    // },
    // change_female(teeboxwoman) {
    //   if (teeboxman === "1") {
    //     this.teemale =
    //       this.$i18n.t("text.common.pro") +
    //       "(" +
    //       this.$i18n.t("text.common.blue") +
    //       ")";
    //   } else if (teeboxman === "2") {
    //     this.teemale =
    //       this.$i18n.t("text.common.regular") +
    //       "(" +
    //       this.$i18n.t("text.common.white") +
    //       ")";
    //   } else if (teeboxman === "3") {
    //     this.teemale =
    //       this.$i18n.t("text.common.lady") +
    //       "(" +
    //       this.$i18n.t("text.common.red") +
    //       ")";
    //   } else {
    //     this.teefemale = teeboxwoman;
    //   }
    // },
  },
  created() {
    this.get_tournamentcondition();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  mixins: [myMixin],
};
</script>
